import { Calendar } from 'assets/icons';
import Button from 'components/button';
import { dateWord } from 'helper/helper';

const LocationSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">Lieu de la mission</span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div className="flex flex-col gap-4">
      <div className="flex flex-col ft-sm">
        <span className="text-gray-900 font-medium">Adresse :</span>{' '}
        {`${dataCreateMission.location.street}, ${dataCreateMission.location.postcode} ${dataCreateMission.location.city}`}
      </div>
      <div className="flex justify-between">
        <div className="flex flex-col ft-sm">
          <span className="text-gray-900 font-medium">
            Période de la mission :
          </span>{' '}
          {dataCreateMission.dateStart && dataCreateMission.dateEnd
            ? `${dateWord(dataCreateMission.dateStart)} au ${dateWord(
                dataCreateMission.dateEnd
              )}`
            : null}
        </div>
        {dataCreateMission.isScheduleCheck && (
          <Button color="SECONDARY" size="SM" onClick={() => setPage(3)}>
            <Calendar wh={18} color="#374151" /> Planning
          </Button>
        )}
      </div>
    </div>
  </div>
);

export default LocationSection;
